const legacyColors = {
  white: {
    500: { value: "#ffffff" } // base.200
  },
  burntYellow: {
    10: { value: "#ffe788" }, // warning.400
    50: { value: "#fbf3e2" },
    100: { value: "#f8eacb" },
    200: { value: "#f5e1b5" },
    300: { value: "#f2d89e" },
    400: { value: "#efcf88" },
    500: { value: "#f0a32f" }, // brand.500
    600: { value: "#EA9B25" },
    700: { value: "#E2931D" },
    800: { value: "#a56225" },
    900: { value: "#8c4d21" }
  },
  coral: {
    500: { value: "#F7936F" }
  },
  ebonyClay: {
    50: { value: "#f7f7f8" },
    100: { value: "#e5e5e7" },
    200: { value: "#c3c3c7" },
    300: { value: "#a1a1a6" },
    400: { value: "#7f7f86" },
    500: { value: "#2b2c3c" },
    600: { value: "#282934" },
    700: { value: "#25252c" },
    800: { value: "#20232b" },
    900: { value: "#1c1e24" }
  },
  mintJade: {
    50: { value: "#f2f9f6" },
    100: { value: "#e6f3ed" },
    200: { value: "#c2e3d6" },
    300: { value: "#9ed3bf" },
    400: { value: "#7ac3a9" },
    500: { value: "#66cb9f" },
    600: { value: "#5dc598" },
    700: { value: "#4BBA89" },
    800: { value: "#3f8673" },
    900: { value: "#326d64" }
  },
  slateGray: {
    500: { value: "#425466" },
    600: { value: "#6b768b" } // base.600
  },
  royalBlue: {
    100: { value: "#F5F8FF" },
    500: { value: "#0066ff" }
  },
  babyBlue: {
    25: { value: "#F5FCFF" }, // action.200
    50: { value: "#E1E8FF" },
    100: { value: "#00a4db" }, // action.500
    400: { value: "#f5fcff" }, // action.200
    500: { value: "#b4cae1" }
  },
  mintGreen: {
    25: { value: "#F3FFDF" }, // success.300
    50: { value: "#DCF6B3" }, // success.400
    400: { value: "#B6DE83" }, // success.500
    500: { value: "#66cb9f" },
    600: { value: "#67a187" },
    700: { value: "#31C48D" }
  },
  sunsetRed: {
    50: { value: "#ffede3" },
    100: { value: "#ffe6e4" }, // danger.300
    300: { value: "#f7c9ca" },
    500: { value: "#f16063" } // danger.500
  },
  oliveBlack: {
    500: { value: "#2b2c3d" } // base.700
  },
  coolMist: {
    50: { value: "#f8fafd" },
    100: { value: "#f1f5fb" },
    200: { value: "#eaedf8" },
    300: { value: "#e3e8f4" },
    400: { value: "#dde4f0" },
    500: { value: "#d6e0ec" },
    600: { value: "#e2e8f1" },
    700: { value: "#b4c1d7" },
    800: { value: "#8b9caf" },
    900: { value: "#637391" }
  },
  gray: {
    50: { value: "#fafafa" }, // base.300
    100: { value: "#f7fafc" },
    150: { value: "#edf2f7" }, // base.400
    200: { value: "#edf2f7" }, // base.400
    300: { value: "#e2e8f0" }, // lines.400
    400: { value: "#cbd5e0" }, // base.500
    500: { value: "#a0aec0" },
    550: { value: "#6b7280" },
    600: { value: "#718096" }, // lines.600
    700: { value: "#4a5568" },
    750: { value: "#374151" },
    800: { value: "#2d3748" },
    900: { value: "#1a202c" }
  },
  lightMist: {
    50: { value: "#F9FAFB" }
  },
  sunnyYellow: {
    100: { value: "#fffdf5" },
    500: { value: "#FFE788" }, // warning.400
    600: { value: "#f7d44f" } // warning.500
  },
  lightBeige: {
    500: { value: "#FEFCF3" } // warning.300
  },
  lightGray: {
    500: { value: "#fbfbfe" }
  },
  darkBlue: {
    500: { value: "#00526e" }, // action.600
    600: { value: "#336e82" }
  },
  danger: {
    100: { value: "#FEF2F3" },
    600: { value: "#C05621" }
  },
  success: {
    100: { value: "#DEFFEE" },
    500: { value: "#66CB9F" },
    600: { value: "#ADCF77" } // success.600
  },
  warning: {
    50: { value: "#FEFCF3" }, // warning.300
    100: { value: "#F7D44F" }, // warning.500
    200: { value: "#FEEBC8" },
    500: { value: "#F7936F" },
    600: { value: "#ffe788" } // warning.400
  },
  duskBlue: {
    100: { value: "#E1EFFE" },
    300: { value: "#68DBF2" },
    500: { value: "#4CAFD0" }
  },
  softLavendar: {
    100: { value: "#EBEBF7" },
    500: { value: "#C2BFE5" } // highlightLilac.500
  },
  paleBlue: {
    500: { value: "#E5EDFF" },
    600: { value: "#3182CE" }
  },
  deepBlue: {
    500: { value: "#00526E" } // action.600
  },
  waxFlower: {
    50: { value: "#fcba9e" } // highlightWax.500
  },
  goldenrod: {
    100: { value: "#FEFCF3" }, // warning.300
    500: { value: "#E1992C" } // brand.600
  }
};

export const colors = {
  ...legacyColors,
  legacy: {
    white: {
      500: { value: "#ffffff" } // base.200
    },
    burntYellow: {
      10: { value: "#ffe788" } // warning.400
    },
    coral: {
      500: { value: "#F7936F" }
    },
    slateGray: {
      500: { value: "#425466" },
      600: { value: "#6b768b" }
    },
    ebonyClay: {
      500: { value: "#2b2c3c" },
      600: { value: "#282934" },
      900: { value: "#1c1e24" }
    },
    deepBlue: {
      500: { value: "#00526E" } // action.600
    },
    royalBlue: {
      100: { value: "#F5F8FF" },
      500: { value: "#0066ff" }
    },
    babyBlue: {
      400: { value: "#f5fcff" }, // action.200
      500: { value: "#b4cae1" }
    },
    mintGreen: {
      500: { value: "#66cb9f" }
    },
    oliveBlack: {
      500: { value: "#2b2c3d" } // base.700
    },
    gray: {
      50: { value: "#fafafa" },
      100: { value: "#f7fafc" },
      200: { value: "#edf2f7" },
      300: { value: "#e2e8f0" }, // lines.400
      400: { value: "#cbd5e0" }, // base.500
      500: { value: "#a0aec0" },
      600: { value: "#718096" }, // lines.600
      800: { value: "#2d3748" },
      900: { value: "#1a202c" }
    },
    danger: {
      100: { value: "#FEF2F3" },
      500: { value: "#F16063" }
    },
    success: {
      100: { value: "#DEFFEE" },
      500: { value: "#66CB9F" }
    },
    warning: {
      600: { value: "#ffe788" } // warning.400
    },
    link: {
      color: { value: "#0066ff" }
    },
    pillTag: {
      border: { value: "#F7936F" }
    },
    bg: {
      value: "#f7fafc" // gray.100 from old theme
    },
    green: {
      value: "#4BBA89"
    },
    yellow: {
      value: "#efcf88"
    }
  },
  brand: {
    400: { value: "#FFBC58" },
    500: { value: "#F0A32F" },
    600: { value: "#E1992C" },
    700: { value: "#6B2912" }
  },
  success: {
    300: { value: "#F3FFDF" },
    400: { value: "#DCF6B3" },
    500: { value: "#B6DE83" },
    600: { value: "#ADCF77" },
    700: { value: "#8CA95E" },
    800: { value: "#55643C" }
  },
  warning: {
    300: { value: "#FEFCF3" },
    400: { value: "#FFE788" },
    500: { value: "#F7D44F" },
    600: { value: "#EDCE57" }
  },
  danger: {
    300: { value: "#FFE6E4" },
    400: { value: "#F68E87" },
    500: { value: "#F16063" },
    600: { value: "#CF4655" }
  },
  action: {
    200: { value: "#F5FCFF" },
    300: { value: "#DDF9FF" },
    400: { value: "#98E5FF" },
    500: { value: "#00A4DB" },
    600: { value: "#00526E" },
    700: { value: "#003547" }
  },
  base: {
    200: { value: "#FFFFFF" },
    300: { value: "#FAFAFA" },
    400: { value: "#EDF2F7" },
    500: { value: "#CBD5E0" },
    600: { value: "#6B768B" },
    700: { value: "#2B2C3D" },
    800: { value: "#1A1A25" }
  },
  lines: {
    400: { value: "#E2E8F0" },
    600: { value: "#718096" }
  },
  highlightWax: {
    500: { value: "#FCBA9E" }
  },
  highlightLilac: {
    500: { value: "#C2BFE5" }
  },
  highlightSpindle: {
    500: { value: "#AFCBE3" }
  }
};

export const semanticGradeThemePrimary = {
  pageBg: {
    DEFAULT: {
      value: { _light: "colors.warning.300", _dark: "colors.base.800" }
    }
  },
  headerBg: {
    DEFAULT: {
      value: { _light: "colors.warning.500", _dark: "colors.brand.700" }
    }
  },
  headerText: {
    DEFAULT: {
      value: { _light: "colors.base.700", _dark: "colors.base.300" }
    }
  },
  headerLogo: {
    DEFAULT: {
      value: { _light: "colors.base.700", _dark: "colors.success.500" }
    }
  },
  footerDivider: {
    DEFAULT: {
      value: {
        _light: "colors.highlightWax.500",
        _dark: "colors.highlightWax.500"
      }
    }
  },
  iconColor: {
    DEFAULT: {
      value: { _light: "colors.base.700", _dark: "colors.base.300" }
    }
  },
  themeSwitchColor: {
    DEFAULT: {
      value: { _light: "colors.base.600", _dark: "colors.warning.500" }
    }
  },
  colorModeIcon: {
    DEFAULT: {
      value: {
        _light: "colors.base.600",
        _dark: "colors.warning.500"
      }
    }
  }
};

export const semanticGradeThemeSecondary = {
  pageBg: {
    DEFAULT: {
      value: { _light: "colors.base.300", _dark: "colors.base.800" }
    }
  },
  headerBg: {
    DEFAULT: {
      value: { _light: "colors.brand.700", _dark: "colors.brand.700" }
    }
  },
  headerText: {
    DEFAULT: {
      value: { _light: "colors.base.200", _dark: "colors.base.200" }
    }
  },
  headerLogo: {
    DEFAULT: {
      value: { _light: "colors.warning.500", _dark: "colors.warning.500" }
    }
  },
  footerDivider: {
    DEFAULT: {
      value: { _light: "colors.brand.700", _dark: "colors.brand.700" }
    }
  },
  iconColor: {
    DEFAULT: {
      value: { _light: "colors.base.200", _dark: "colors.base.200" }
    }
  },
  themeSwitchColor: {
    DEFAULT: {
      value: { _light: "colors.base.400", _dark: "colors.warning.500" }
    }
  },
  colorModeIcon: {
    DEFAULT: {
      value: {
        _light: "colors.base.500",
        _dark: "colors.warning.500"
      }
    }
  }
};

export const semanticGradeThemeSenior = {
  pageBg: {
    DEFAULT: {
      value: { _light: "colors.base.300", _dark: "colors.base.800" }
    }
  },
  headerBg: {
    DEFAULT: {
      value: { _light: "colors.base.700", _dark: "colors.base.700" }
    }
  },
  headerText: {
    DEFAULT: {
      value: { _light: "colors.base.200", _dark: "colors.base.200" }
    }
  },
  headerLogo: {
    DEFAULT: {
      value: { _light: "colors.base.300", _dark: "colors.base.300" }
    }
  },
  footerDivider: {
    DEFAULT: {
      value: { _light: "colors.action.600", _dark: "colors.action.600" }
    }
  },
  iconColor: {
    DEFAULT: {
      value: { _light: "colors.base.200", _dark: "colors.base.200" }
    }
  },
  themeSwitchColor: {
    DEFAULT: {
      value: { _light: "colors.base.400", _dark: "colors.warning.500" }
    }
  },
  colorModeIcon: {
    DEFAULT: {
      value: {
        _light: "colors.base.500",
        _dark: "colors.warning.500"
      }
    }
  }
};

export const semanticColors = {
  canvas: {
    DEFAULT: {
      value: { _light: "colors.base.200", _dark: "colors.base.700" }
    },
    dim: {
      value: { _light: "colors.base.300", _dark: "colors.base.800" }
    },
    parchment: {
      value: { _light: "colors.warning.300", _dark: "colors.base.800" }
    },
    colourful: {
      value: { _light: "colors.warning.500", _dark: "colors.brand.700" }
    }
  },
  lines: {
    DEFAULT: {
      value: { _light: "colors.lines.400", _dark: "colors.lines.600" }
    }
  },
  text: {
    DEFAULT: {
      value: { _light: "colors.base.700", _dark: "colors.base.300" }
    },
    soft: {
      value: { _light: "colors.base.600", _dark: "colors.base.500" }
    },
    action: {
      value: { _light: "colors.action.600", _dark: "colors.action.400" }
    },
    error: {
      value: { _light: "colors.danger.600", _dark: "colors.danger.400" }
    }
  },
  error: {
    text: {
      value: { _light: "colors.danger.600", _dark: "colors.danger.400" }
    },
    element: {
      value: { _light: "colors.danger.500", _dark: "colors.danger.400" }
    }
  },
  button: {
    bg: {
      filled: {
        value: {
          _light: "colors.action.600",
          _dark: "colors.action.400"
        }
      },
      filledHover: {
        value: {
          _light: "colors.action.700",
          _dark: "colors.action.500"
        }
      },
      hollow: {
        value: { _light: "colors.base.200", _dark: "colors.base.700" }
      },
      disabled: {
        value: { _light: "colors.base.500", _dark: "colors.base.500" }
      },
      disabledHollow: {
        value: { _light: "colors.base.300", _dark: "colors.base.800" }
      }
    },
    label: {
      filled: {
        value: { _light: "colors.base.200", _dark: "colors.base.700" }
      },
      hollow: {
        value: {
          _light: "colors.action.600",
          _dark: "colors.action.400"
        }
      },
      hollowHover: {
        value: {
          _light: "colors.action.700",
          _dark: "colors.action.500"
        }
      },
      disabled: {
        value: { _light: "colors.base.600", _dark: "colors.base.600" }
      },
      disabledHollow: {
        value: { _light: "colors.base.600", _dark: "colors.base.600" }
      },
      link: {
        value: {
          _light: "colors.legacy.link.color",
          _dark: "colors.legacy.link.color"
        }
      }
    },
    border: {
      filled: {
        value: {
          _light: "colors.action.600",
          _dark: "colors.action.400"
        }
      },
      filledHover: {
        value: {
          _light: "colors.action.700",
          _dark: "colors.action.500"
        }
      },
      hollow: {
        value: {
          _light: "colors.action.600",
          _dark: "colors.action.400"
        }
      },
      hollowHover: {
        value: {
          _light: "colors.action.700",
          _dark: "colors.action.500"
        }
      },
      disabled: {
        value: {
          _light: "colors.base.600",
          _dark: "colors.base.600"
        }
      },
      disabledHollow: {
        value: {
          _light: "colors.lines.400",
          _dark: "colors.lines.600"
        }
      }
    }
  },
  input: {
    DEFAULT: {
      value: { _light: "colors.base.200", _dark: "colors.base.200" }
    },
    focus: {
      value: { _light: "colors.action.600", _dark: "colors.action.400" }
    }
  },
  gradeTheme: semanticGradeThemeSenior
};
